// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"a4645f0d","338":"beb8c63c","349":"569a9b79","393":"9dbc61bf","554":"703ecb34","858":"c1f66ef4","860":"429ae9fb","974":"72a71fba"}[chunkId] + ".chunk.js";
};